// extracted by mini-css-extract-plugin
export default {"containerImagen":"imagen_containerImagen__LNZZo","aboutImage":"imagen_aboutImage__MYvl+"};